import { gql } from '@apollo/client';

// ================== 배너 관련 ==================
export const GET_BANNERS_QUERY = gql`
  query GetBanners {
    banners {
      id
      position
      imageUrl
      linkUrl
      width
      height
      backgroundColor
      bannerText
      order
      isVisible
      createdAt
    }
  }
`;

export const GET_BANNER_BY_ID_QUERY = gql`
  query GetBannerById($id: Int!) {
    banner(id: $id) {
      id
      position
      imageUrl
      linkUrl
      width
      height
      backgroundColor
      bannerText
      order
      isVisible
      createdAt
      updatedAt
    }
  }
`;

export const GET_BANNERS_BY_POSITION_QUERY = gql`
  query GetBannersByPosition($position: String!) {
    bannersByPosition(position: $position) {
      id
      position
      imageUrl
      linkUrl
      width
      height
      backgroundColor
      bannerText
      order
      isVisible
      createdAt
    }
  }
`;

export const CREATE_BANNER_MUTATION = gql`
  mutation CreateBanner($input: BannerCreateInput!) {
    createBanner(input: $input) {
      id
      position
      imageUrl
      linkUrl
      width
      height
      backgroundColor
      bannerText
      order
      isVisible
      createdAt
    }
  }
`;

export const UPDATE_BANNER_MUTATION = gql`
  mutation UpdateBanner($id: Int!, $input: BannerUpdateInput!) {
    updateBanner(id: $id, input: $input) {
      id
      position
      imageUrl
      linkUrl
      width
      height
      backgroundColor
      bannerText
      order
      isVisible
      updatedAt
    }
  }
`;

export const DELETE_BANNER_MUTATION = gql`
  mutation DeleteBanner($id: Int!) {
    deleteBanner(id: $id)
  }
`; 